import React, { Component } from "react";
import Image from '../global/Image';
import { Link } from 'react-router-dom';

export default class PageProjectThumb extends Component {
  	
	render () {
		
		let item 		= this.props.item;
	
		if (item) {
						
		    return (
			    
			    <div className="c-projects__thumb">
										
					<Link to={{ pathname: item.url }} className="c-projects__thumb__inner">
					
						<div className="c-projects__thumb__media">
							<Image srcset={item.srcset} src={item.src} />
						</div>
												
						<h4 className="c-projects__thumb__title" dangerouslySetInnerHTML={ {__html:item.title}}></h4>
						{item.subtitle &&
							<h5 className="c-projects__thumb__subtitle" dangerouslySetInnerHTML={ {__html:item.subtitle}}></h5>
						}		
						
						<div className="c-projects__thumb__meta">
							<div className="c-project__meta c-project__meta--small">
								{item.meta.map((meta,i) =>
									{
										return (
											<div className="c-project__meta__item">
												{meta.label &&
													<h5 className="c-project__meta__item__label" dangerouslySetInnerHTML={{__html:meta.label}}></h5>
												}
												{meta.progress &&
													<div className="c-project__meta__item__bar">
														<div className="c-project__meta__bar__inset" style={{width:meta.progress+'%'}}></div>
													</div>
												}
												{meta.text &&
													<p className="c-project__meta__item__text" dangerouslySetInnerHTML={{__html:meta.text}}></p>
												}
											</div>
										)
									}
								)}
							</div>
						</div>
											
					</Link>
					
				</div>
			)
			
		} else {
			
			return null;
		
		}
	}
}
